import { api } from '@marketplace-web/core-api/core-api-client-util'

import { ModerateFeedbackArgs } from '../types/feedback'

export const moderateFeedback = ({ feedbackId, userId, otherUserId }: ModerateFeedbackArgs) =>
  api.post('/notices/feedbacks', {
    feedback_id: feedbackId,
    user_id: userId,
    other_user_id: otherUserId,
  })
